// PrivateRoute.js
import React from 'react';
import { getAuth } from 'firebase/auth';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const auth = getAuth();
  const user = auth.currentUser;

  return user ? children : <Navigate to="/signin" />;
};

export default PrivateRoute;
